import firebase from "firebase/app";
import "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyBIMcXHiT74DRbWjJhjl-4CXF6sPCNgSVs",
  authDomain: "visitors-traffic.firebaseapp.com",
  databaseURL: "https://visitors-traffic.firebaseio.com",
  projectId: "visitors-traffic",
  storageBucket: "visitors-traffic.appspot.com",
  messagingSenderId: "614319337696",
  appId: "1:614319337696:web:a2fd172e330308cbbda085",
  measurementId: "G-H911VHGHYP"
};

class Database {
    public database: any

    constructor() {
        const base = firebase.initializeApp(firebaseConfig);
        this.database = base.database();
    }

    getTokenData = (token: string) => this.database.ref(`${token}`);
}

export default new Database();

